import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "animate.css";

const showNotification = (title, message, type = "success") => {
    console.log("showNotification called with:", { title, message, type });

    try {
        Store.addNotification({
            title: title,
            message: message,
            type: type, // "success", "danger", "info", "default", "warning"
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true,
                showIcon: true,
                click: true,
                pauseOnHover: true
            }
        });
        console.log("Store.addNotification completed successfully");
    } catch (error) {
        console.error("Error in showNotification:", error);
    }
};

export default showNotification;
